import { BibliographyClass } from '@/types'
import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface BookbindingTargetMagazineCollection {
  collectionId: number
  collectionNo: string
  collectionStatus: SystemCode
  holdingBranchCode: SystemCode
  bibliographyClass: BibliographyClass
  displayTitle: string
  displayContent: string
  volume: string
  volumeNumber: string
  volumeTotal: string
  volumeDateLabel: string
  volumeSpecial: string
}

export function BookbindingTargetMagazineCollectionFromJSON(
  json: any
): BookbindingTargetMagazineCollection {
  return {
    collectionId: exists(json, 'collection_id') ? json.collection_id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    collectionStatus: exists(json, 'collection_status')
      ? SystemCodeFromJSON(json.collection_status)
      : defaultSystemCode(),
    holdingBranchCode: exists(json, 'holding_branch_code')
      ? SystemCodeFromJSON(json.holding_branch_code)
      : defaultSystemCode(),
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayContent: exists(json, 'display_content') ? json.display_content : '',
    volume: exists(json, 'volume') ? json.volume : '',
    volumeNumber: exists(json, 'volume_number') ? json.volume_number : '',
    volumeTotal: exists(json, 'volume_total') ? json.volume_total : '',
    volumeDateLabel: exists(json, 'volume_date_label')
      ? json.volume_date_label
      : '',
    volumeSpecial: exists(json, 'volume_special') ? json.volume_special : ''
  }
}
